module.exports = __webpack_public_path__ + "static/media/card_icon_3.657e7c31.png";